module.exports = __webpack_public_path__ + "static/media/Taiwan.5a67d3eb.png";